import React from 'react';
import { EditQuestion } from './QuestionForm';
export default function QuestionEdit({ question }) {
  return <EditQuestion question={question} />;
}
